import { render, staticRenderFns } from "./splitButton.vue?vue&type=template&id=bc9d2a5a&"
import script from "./splitButton.vue?vue&type=script&lang=ts&"
export * from "./splitButton.vue?vue&type=script&lang=ts&"
import style0 from "./splitButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports